import { render, staticRenderFns } from "./AddFirstAndLastNameToCompanyUser.vue?vue&type=template&id=19b01368&"
import script from "./AddFirstAndLastNameToCompanyUser.vue?vue&type=script&lang=ts&"
export * from "./AddFirstAndLastNameToCompanyUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports